import React, { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Box, Spinner, Text, Flex, Image, Heading, useToast, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, Input, Checkbox, FormControl, FormLabel, useColorMode } from "@chakra-ui/react";
import OfficeInfo from "./OfficeInfo";
import RegisterModal from "./RegisterModal";
import FullScreenMessage from "./FullScreenMessage";
import moment from "moment";
import { cqAPI } from "../../../lib/Auth";

const Availabilities = () => {
  const { serviceId, date } = useParams();
  const [hasError, setHasError] = useState(false);
  const day = date.replace(/-/g, "/");
  const navigate = useNavigate();
  const location = useLocation();
  const [availability, setAvailability] = useState([]);
  const [service, setService] = useState({});
  const [officeData, setOfficeData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedTimeSlot, setSelectedTimeSlot] = useState(null);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [serverMessage, setServerMessage] = useState("");
  const { colorMode } = useColorMode();
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phoneNumber: "",
    terms: false,
  });

  useEffect(() => {
    setIsLoading(true);
    cqAPI
      .get(`/times?service_id=${serviceId}&day=${day}`)
      .then((data) => {
        if (data.type === "ok") {
          setAvailability(data.data.availabilities);
          setService(data.data.service);
          setOfficeData(data.data.business);
        } else {
          if (data.code) {
            setHasError(true);
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        setHasError(true);
        setIsLoading(false);
      });
  }, [serviceId, day]);

  if (hasError) {
    return <FullScreenMessage message="This is not a valid link" />;
  }

  if (isLoading) {
    return (
      <Flex justifyContent="center" alignItems="center" height="100vh">
        <Spinner size="xl" />
      </Flex>
    );
  }

  const handleDayClick = (timeInfo) => {
    setSelectedTimeSlot(timeInfo);
    setIsModalOpen(true);
  };

  const changeDay = () => {
    navigate({
      pathname: `/appointments/new/service/${serviceId}`,
      search: location.search,
    });
  };

  const handleRegister = (e) => {
    cqAPI.post('/pp/book',{
      appointment: { ...selectedTimeSlot }
    }).then(data => {
      if (data.type === 'ok') {
        setIsModalOpen(false);
        if (data.msg) {
          setServerMessage(data.msg);
          setIsConfirmModalOpen(true);
        }
        navigate({
          pathname: `/appointments`,
          search: location.search,
        });
      }
    })
  };

  return (
    <Box padding="40px" bg={colorMode === "light" ? "white" : "gray.800"} borderRadius="md" boxShadow="md" className="availability-container availability-day">
      <Text className="instruction" fontSize="md">
        Select the time. You will review and confirm next.
      </Text>
      <Flex justifyContent="space-between" alignItems="center" borderBottom="1px solid gray" pb={2} mb={4}>
        <Text></Text>
        <Text className="change-service" onClick={changeDay} cursor="pointer" color="blue.500">
          Change Date
        </Text>
      </Flex>
      {availability.map((dayInfo, index) => (
        <Box
          key={index}
          className="day-block actionableItem"
          onClick={() => handleDayClick(dayInfo)}
          border="1px"
          borderColor="gray.200"
          borderRadius="md"
          p={4}
          mb={4}
          cursor="pointer"
          _hover={{ bg: "gray.100" }}
        >
          <Flex alignItems="center">
            <Image src={dayInfo.img} alt={dayInfo.name} boxSize="50px" borderRadius="full" mr={4} />
            <Box>
              <Heading as="h4" size="md">
                {dayInfo.title ? dayInfo.title + " " : ""}
                {dayInfo.name}
              </Heading>
              <Text>{dayInfo.time}</Text>
            </Box>
          </Flex>
        </Box>
      ))}
      {isModalOpen && (
        <RegisterModal
          onRegister={handleRegister}
          onClose={() => setIsModalOpen(false)}
          selectedTimeSlot={selectedTimeSlot}
        />
      )}
      {isConfirmModalOpen && (
        <Modal isOpen={isConfirmModalOpen} onClose={() => setIsConfirmModalOpen(false)}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Confirmation</ModalHeader>
            <ModalBody>
              <Text>{serverMessage}</Text>
            </ModalBody>
            <ModalFooter>
              <Button onClick={() => setIsConfirmModalOpen(false)}>Close</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      )}
    </Box>
  );
};

export default Availabilities;
